export default __webpack_public_path__ + "static/media/photo--lg--huda-3.04f91bbd.jpg";